import { ITranslate } from 'locale';
import { SchoolLevel, OldSchoolLevel } from 'store/sagas/apiService/types';

function getIsHighSchool(schoolLevel: SchoolLevel | OldSchoolLevel): boolean {
  return (schoolLevel === SchoolLevel.HIGHSCHOOL) || (schoolLevel === OldSchoolLevel.HIGHSCHOOL);
}

export function createFullSchoolName(schoolName: string, t: ITranslate, schoolLevel: SchoolLevel | OldSchoolLevel): string {
  const isHighSchool = getIsHighSchool(schoolLevel);
  if (schoolName) {
    const prefix = isHighSchool ? t('dataLayerPreview.ilSchools.highSchoolPrefix') : t('dataLayerPreview.ilSchools.elementarySchoolPrefix');
    const prefixInSchoolName = schoolName.includes(prefix);
    if (prefixInSchoolName) return schoolName;
    return addPrefix(schoolName, t, schoolLevel);
  }
  return schoolName;
}

function addPrefix(schoolName: string, t: ITranslate, schoolLevel: SchoolLevel | OldSchoolLevel): string {
  if (schoolName) {
    const schoolNameChunks = schoolName.split(' ');
    if (schoolNameChunks.length > 2) {
      schoolNameChunks.splice(2, 0, t('schoolPage.school.name', { schoolLevel }));
      return schoolNameChunks.join(' ');
    }
  }
  return schoolName;
}
